/* eslint-disable no-console */
/**
 * Canonical Firebase configuration for the web app.
 *
 * This is the single source of truth for the Firebase project credentials used
 * by the client (Firebase JS SDK) and — via scripts/build-sw.cjs — by the
 * generated production service worker. All values are public client
 * configuration and must match the native config (google-services.json /
 * GoogleService-Info.plist).
 */
export const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

/**
 * VAPID public key used to subscribe the web browser to FCM. Only required on
 * web; native platforms use google-services.json / GoogleService-Info.plist.
 */
export const FCM_VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY;

/**
 * True when every value required to bootstrap the Firebase app is present.
 */
export function isFirebaseConfigComplete() {
  return Boolean(
    FIREBASE_CONFIG.apiKey &&
      FIREBASE_CONFIG.authDomain &&
      FIREBASE_CONFIG.projectId &&
      FIREBASE_CONFIG.messagingSenderId &&
      FIREBASE_CONFIG.appId
  );
}

export function warnOnMissingFirebaseConfig() {
  if (isFirebaseConfigComplete()) return;
  const missing = Object.entries(FIREBASE_CONFIG)
    .filter(([, value]) => !value)
    .map(([key]) => key);
  console.error(
    "[Firebase] Invalid app configuration. Missing values:",
    missing.join(", ")
  );
}